import React from 'react';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Container, Image } from 'react-bootstrap'
import './CustomNavbar.css';

import { FaTwitter, FaSteam, FaYoutube, FaInstagram } from 'react-icons/fa';



const CustomNavbar = () => {

    // const openInNewTab = (url) => {
    //     const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    //     if (newWindow) newWindow.opener = null
    // }

    return (
        <Navbar className="customNavBarStyle" >
            <Container>
                <Navbar.Brand href="/">
                    <Image src="assets/FOTWLogo.png"></Image>
                </Navbar.Brand>
                {/* <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbarToggle-Icon"> <HiMenu /> </Navbar.Toggle> */}
                {/* <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-start"> */}

                <Nav className="customNavBarStyle-links">
                    <Nav.Link href="https://store.steampowered.com/app/2452320/Folly_Of_The_Wizards/" rel="noopener noreferrer" target="_blank" ><FaSteam></FaSteam></Nav.Link>
                    <Nav.Link href="https://twitter.com/FollyOTWizards" rel="noopener noreferrer" target="_blank"><FaTwitter></FaTwitter></Nav.Link>
                    {/* <Nav.Link href="/#" rel="noopener noreferrer" target="_blank"  ><FaTiktok></FaTiktok></Nav.Link> */}
                    <Nav.Link href="https://www.youtube.com/@FollyOfTheWizards" rel="noopener noreferrer" target="_blank"  ><FaYoutube></FaYoutube></Nav.Link>
                    <Nav.Link href="https://instagram.com/FollyOfTheWizards" rel="noopener noreferrer" target="_blank"><FaInstagram></FaInstagram></Nav.Link>
                </Nav>
                {/* </Navbar.Collapse> */}
            </Container>
        </Navbar>

    );
}




export default CustomNavbar;

